module.exports = __webpack_public_path__ + "static/media/analytics.349c96e0.png";